import { IUnitOption } from '../../options/store/options.types'
import { AIR_UNIT_TYPES } from '../../tripInformation/store/tripInformation.constants'

export const showAtLanding = (unit: IUnitOption | null) => {
  const selectedUnitType = unit?.unitType ?? null
  return selectedUnitType !== null && AIR_UNIT_TYPES.includes(selectedUnitType) && unit?.atLanding === 1
}

export const showDescent = (unit: IUnitOption | null, AIR: number | null) => {
  return AIR === 1 && unit?.descent === 1
}
